import URL from "core/resources/urls";
import http from "infra/http";
import { useQuery } from "react-query";

export default function useGetOcupacoes() {
  return useQuery(
    [URL.OCUPACOES.OBTER],
    async () => {
      const { data } = await http.get(URL.OCUPACOES.OBTER, {
        params: {
          exibir: true,
        },
      });

      return data as any[];
    }
  );
}
